import { sports } from "../../../components/Util/enum";

/**
 * Documenti caricati dagli utenti in attesa di convalida (certificati medici, tesserini, titoli di studio),
 * come li mostrano la lista «Documenti da validare» e la scheda del documento.
 */
export const caricaDocumentiDaValidare = async (apiClient, token) => {
    const [medicalCertificates, licenses, educations] = await Promise.all([
        apiClient.getMedicalCertificatesToApprove(token),
        apiClient.getLicensesToApprove(token),
        apiClient.getEducationsToApprove(token)
    ]);

    const documents = [];
    (medicalCertificates || []).forEach(element => documents.push({ ...element, type: 'Certificato medico', code_type: 'MEDICAL_CERTIFICATE' }));
    (licenses || []).forEach(element => documents.push({ ...element, type: 'Tesserino', code_type: 'LICENSE' }));
    (educations || []).forEach(element => documents.push({ ...element, type: 'Titolo di studio', code_type: 'EDUCATION' }));

    return documents.map(element => {
        const sport_decode = sports.find(s => s.value === element.sportType)?.label || '';
        const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
        const formattedDate = new Date(element.document.uploadedAt).toLocaleDateString('it-IT', options);
        return {
            "userId": element.userId,
            "imageUrl": element.picture && element.picture.uri ? element.picture.uri : null,
            "data-caricamento": formattedDate,
            "nome-documento": element.document.name,
            "tipologia": element.type,
            "name": element.name,
            "uri": element.document.uri,
            "documentId": element.document.id,
            "verificationCode": element.verificationCode,
            "documentType": element.code_type,
            "sport": sport_decode
        };
    });
};
